module.exports = {
  path: '/'
}


// WEBPACK FOOTER //
// ./src/config/index.js